import React from 'react';

const Loading = ({ text = "Cargando...", height = "100vh" }) => {
  return (
    <div style={{ fontSize: "30px" }} className="container-fluid ff-bobby">
      <div style={{ height }} className="row justify-content-center align-items-center text-center">
        {text}
      </div>
    </div>
  );
};

export default Loading;
